export default {
  namespaced: true,
  state: {
    creatorUrl: `/api/creator/`,
    creatorInfo: {},
  },
  getters: {
    creatorInfo: (state) => state.creatorInfo,
  },
  mutations: {
    setCreatorInfo(state, data) {
      state.creatorInfo = data;
    },
  },
  actions: {
    async getCreatorDataBytoken({ state, commit }) {
      try {
        let res = await axios.get(state.creatorUrl);
        commit("setCreatorInfo", res.data);
        commit(
          "creative/insertIsSuitCreatorLevelToTypeInfo",
          res.data.creator_level,
          {
            root: true,
          }
        );
      } catch (e) {
        throw e;
      }
    },
  },
};
